import { FaAngleDoubleLeft } from "react-icons/fa";
import { FaAngleDoubleRight } from "react-icons/fa";
import styles from "./Hamburger.module.css"

const Hamburg = ({ hideCard, isCollapsed }) => {
    return (
        <div
            style={{
                // left: isCollapsed ? "97%" : "80%"
                left:"96%"
            }}
            className={`${styles.ham} h-screen flex items-center justify-center animate_transit`}
            onClick={() => hideCard()}
        >
           {isCollapsed ?  <FaAngleDoubleLeft color="cyan" size={24} /> : <FaAngleDoubleRight color="cyan" size={24} />}
        </div>
    );
};

export default Hamburg;
